import React, { useState } from "react";

/**
 * Franja fija que aparece solo en el ambiente de pruebas (REACT_APP_ENV=staging).
 * Existe para que nadie confunda pruebas con el sistema real: aquí los datos son una copia
 * y nada de lo que se haga afecta a un alumno de verdad.
 */
const StagingBanner: React.FC = () => {
	const [hidden, setHidden] = useState<boolean>(false);
	if (process.env.REACT_APP_ENV !== "staging" || hidden) return null;
	return <div style={{
		position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 3000,
		background: "var(--wa-oro)", color: "#FFF", fontSize: "13px", lineHeight: 1.35,
		padding: "7px 14px", display: "flex", alignItems: "center", gap: "10px",
		boxShadow: "0 -2px 10px rgba(0,0,0,0.2)"
	}}>
		<b style={{ letterSpacing: ".04em" }}>PRUEBAS</b>
		<span style={{ flex: 1 }}>
			Este no es el sistema real. Los datos son una copia y nada de lo que hagas aquí afecta a un alumno.
			Para lo del día a día usa wapp.washingtonacademy.com.
		</span>
		<button type="button" onClick={() => setHidden(true)}
			style={{ background: "rgba(255,255,255,0.2)", color: "var(--wa-superficie)", border: "none", borderRadius: "999px", padding: "2px 12px", fontSize: "12px", cursor: "pointer" }}>
			Ocultar
		</button>
	</div>;
};

export default StagingBanner;
